var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8584 6.56412C4.8584 4.97808 6.26496 3.69232 8.00013 3.69232C9.73531 3.69232 11.1419 4.97808 11.1419 6.56412C11.1419 8.1502 9.7353 9.43591 8.00013 9.43591C6.26496 9.43591 4.8584 8.1502 4.8584 6.56412ZM8.00013 5.12822C7.13254 5.12822 6.42926 5.77109 6.42926 6.56412C6.42926 7.35717 7.13253 8.00001 8.00013 8.00001C8.86773 8.00001 9.571 7.35717 9.571 6.56412C9.571 5.77109 8.86772 5.12822 8.00013 5.12822Z",
    fill: "#727190"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 6.54545C1 2.9305 4.13401 0 8 0C11.866 0 15 2.9305 15 6.54545C15 8.38268 14.108 9.9929 12.894 11.4669C11.8795 12.6986 10.5811 13.9022 9.28401 15.1046C9.03864 15.332 8.79332 15.5594 8.54997 15.787C8.24623 16.071 7.75377 16.071 7.45003 15.787C7.20669 15.5594 6.96137 15.332 6.716 15.1046C5.41891 13.9022 4.12048 12.6987 3.10601 11.4669C1.89198 9.9929 1 8.38268 1 6.54545ZM8 1.45455C4.99312 1.45455 2.55556 3.73382 2.55556 6.54545C2.55556 7.92154 3.21913 9.2204 4.33844 10.5794C5.28353 11.7269 6.49321 12.8489 7.79172 14.0533C7.86091 14.1174 7.93034 14.1818 8 14.2465C8.06966 14.1818 8.13909 14.1174 8.20828 14.0533C9.50679 12.8489 10.7165 11.7269 11.6616 10.5794C12.7809 9.2204 13.4444 7.92154 13.4444 6.54545C13.4444 3.73382 11.0069 1.45455 8 1.45455Z",
    fill: "#727190"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.2c6336ccdef4b722cc4d28c93b3ce1b5.svg";
export { ForwardRef as ReactComponent };